<template>
  <div class="accordion" :class="{ accordion_open: isOpen }">
    <button class="accordion__header" @click="toggle">
      <slot name="header" />
      <icon name="arrow-down" width="16px" height="16px" />
    </button>
    <div class="accordion__content content" v-show="isOpen">
      <slot />
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      isOpen: false
    };
  },

  methods: {
    toggle() {
      this.isOpen = !this.isOpen;
    }
  }
};
</script>

<style lang="scss" scoped>
@import "@v2/app/styles/media";
.accordion {
  $component: &;

  &__header {
    padding: 21px 33px 25px 0;
    font-family: Roboto, serif;
    font-size: 16px;
    text-align: left;
    line-height: 1.23;
    font-weight: 400;
    cursor: pointer;
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
    box-sizing: border-box;
    border: none;
    outline: none;
    border-top: 1px solid #d7d7d7;
    border-bottom: 1px solid #d7d7d7;
    margin-top: -1px;
    background: none;

    @include respond-down(md) {
      font-size: 12px;
    }

    svg {
      transition: all 0.2s;
      fill: #767676;
    }

    &:hover {
      color: #005197;
    }

    &:active {
      color: #005197;

      svg {
        transform: rotate(180deg);
        fill: #005197;
      }
    }
  }

  &_open &__header {
    svg {
      transform: rotate(180deg);
    }
  }

  &_open#{$component}_no_border_on_open &__header {
    border-bottom: 0;
  }
}
</style>
